const StarBorder = ({
  children,
  className = '',
  color = '#b8975a',       // золотой
  speed = '2s',            // медленный
  intensity = 2,          // общая яркость бликов (0–1)
  ...props
}) => {
  return (
    <div
      className={`relative overflow-hidden rounded-[28px] group h-full ${className}`}
      {...props}
    >
      {/* Верхний пучок света — строго по верхнему краю */}
      <div
        className="
          absolute left-0 right-0 h-[40px] -top-[20px] opacity-0 
          group-hover:opacity-[var(--intensity)] pointer-events-none z-0
          transition-opacity duration-600
        "
        style={{
          '--intensity': intensity,
          background: `linear-gradient(to bottom, transparent 0%, ${color} 30%, ${color} 70%, transparent 100%)`,
          boxShadow: `0 0 30px ${color}, 0 0 60px ${color}40`,
          animation: 'star-movement-top linear infinite alternate',
          animationDuration: speed,
        }}
      />

      {/* Нижний пучок света — строго по нижнему краю */}
      <div
        className="
          absolute left-0 right-0 h-[40px] -bottom-[20px] opacity-0 
          group-hover:opacity-[var(--intensity)] pointer-events-none z-0
          transition-opacity duration-600
        "
        style={{
          '--intensity': intensity,
          background: `linear-gradient(to top, transparent 0%, ${color} 30%, ${color} 70%, transparent 100%)`,
          boxShadow: `0 0 30px ${color}, 0 0 60px ${color}40`,
          animation: 'star-movement-bottom linear infinite alternate',
          animationDuration: speed,
        }}
      />

      {/* Основной контент карточки */}
      <div className="relative z-10 h-full glass-card p-8 md:p-10 flex flex-col">
        {children}
      </div>
    </div>
  );
};

export default StarBorder;